// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1xZsy","validationTips":"StatementDescriptor_validationTips__3IU3Y"};